import * as $ from "jquery";

export default {
  enforceImageMaxSize(file, maxWidth, maxHeight) {
    return new Promise((resolve, reject) => {
      //This does not work on iOS, so we disable it for now
      var iOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (iOS) {
        resolve(file);
        return;
      }
      // Create an image
      // Set the image once loaded into file reader
      var img = document.createElement("img");
      // Create a file reader
      var reader = new FileReader();
      reader.onload = function (e) {
        img.src = e.target.result;
        img.onload = () => {
          var width = img.width;
          var height = img.height;

          if (img.width <= maxWidth && img.height <= maxHeight) {
            resolve(file);
            return;
          }

          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }

          var canvas = document.createElement("canvas");
          //var canvas = $("<canvas>", {"id":"testing"})[0];
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          canvas.width = width;
          canvas.height = height;
          ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            var newFile = new File([blob], file.name, { type: "image/png" });
            resolve(newFile);
          });
        };

        // document.getElementById('image').src = dataurl;
      };
      // Load files into file reader
      reader.readAsDataURL(file);
    });
  },

  photoJShop(object, options) {
    //Adapted from the photoJShop jQuery plugin
    //https://github.com/aurbano/photojshop
    //https://opensource.org/licenses/MIT
    var settings = $.extend(
      {
        effect: null, // Filter to perform
        color: null, // Color effect
        replace: true, // Replace original
        matrix: null, // Custom effect matrix
      },
      options
    );
    if (typeof options === "string") {
      settings.effect = options;
    }
    // Internal variables
    var obj = object,
      srcCanvas = object,
      destCanvas = document.createElement("canvas"),
      srcCtx = null,
      destCtx = destCanvas.getContext("2d"),
      srcImgd = null,
      destImgd = null,
      effects = {
        blur: [
          [1, 1, 1],
          [1, 1, 1],
          [1, 1, 1],
        ],
        blur2: [
          [1, 1, 1, 1],
          [1, 1, 1, 1],
          [1, 1, 1, 1],
          [1, 1, 1, 1],
        ],
        sharpen: [
          [0, -1, 0],
          [-1, 13, -1],
          [0, -1, 0],
        ],
        emboss: [
          [-10, -7, 0],
          [10, 8, -10],
          [0, 7, 10],
        ],
        lighten: [[1.1]],
        darken: [[0.9]],
        "edge-enhance": [
          [0, 0, 0],
          [-20, 20, 0],
          [0, 0, 0],
        ],
        "edge-detect": [
          [0, 9, 0],
          [9, -40, 9],
          [0, 9, 0],
        ],
        "hard-edge": [
          [2, 22, 1],
          [22, 1, -22],
          [1, -22, -2],
        ],
        laplace: [
          [-2, -2, -2],
          [-2, 15, -2],
          [-2, -2, -2],
        ],
      },
      colorEffects = {
        "b&w": [
          [1, 1, 1],
          [1, 1, 1],
          [1, 1, 1],
        ],
        sepia: [
          [1.2, 1.1, 1],
          [0.8, 0.7, 0.6],
          [0.3, 0.2, 0.1],
        ],
        vintage: [
          [4, 0.5, -0.6],
          [-0.2, 3.1, -0.1],
          [0.6, 0.4, 2],
        ],
        recolor: [
          [0.1, 1.5, 1.5],
          [1.5, 0.1, 1.5],
          [1.5, 1.5, 0.1],
        ],
        red: [
          [3, 0, 0],
          [3, 0, 0],
          [3, 0, 0],
        ],
        blue: [
          [0, 0, 3],
          [0, 0, 3],
          [0, 0, 3],
        ],
        green: [
          [0, 3, 0],
          [0, 3, 0],
          [0, 3, 0],
        ],
      };

    destCanvas.width = object.width();
    destCanvas.height = object.height();

    // Fill with empty pixels
    destCtx.beginPath();
    destCtx.rect(0, 0, destCanvas.width, destCanvas.height);
    destCtx.fillStyle = "rgba(0,0,0,0)";
    destCtx.fill();
    destImgd = destCtx.getImageData(0, 0, destCanvas.width, destCanvas.height);

    // Check if we are operating on an image or in a canvas
    if (object.is("img")) {
      object[0].crossOrigin = "Anonymous";

      // Create a canvas element
      srcCanvas = document.createElement("canvas");
      srcCtx = srcCanvas.getContext("2d");
      // Resize canvas to fit img
      srcCanvas.width = object.width();
      srcCanvas.height = object.height();
      // srcCanvas.width = this[0].naturalWidth;
      // srcCanvas.height = this[0].naturalHeight;
      // Draw image into canvas
      srcCtx.drawImage(object.get(0), 0, 0);
      srcImgd = srcCtx.getImageData(0, 0, srcCanvas.width, srcCanvas.height);
      // Apply desired filter
      return applyEffect();
    } else if (!object.is("canvas")) {
      alert("Unsupported element");
      return;
    }
    srcCtx = srcCanvas.getContext("2d");
    srcImgd = srcCtx.getImageData(0, 0, object.width(), object.height());

    // --------- IMAGE FUNCTIONS ----------- //

    return applyEffect();

    /**
     * Applies a given effect to the canvas
     */
    function applyEffect(callback) {
      // Local variables
      var src = srcImgd,
        dest = destImgd,
        mat = settings.matrix,
        colorMat = null,
        current = 0,
        channel = 0,
        row,
        col,
        sum;

      // Effect matrix
      if (mat === null && settings.effect !== null)
        mat = effects[settings.effect];
      if (mat === null && settings.color === null) {
        console.error(
          "PhotoJShop error: Please specify an effect or custom matrix"
        );
        return obj;
      } else if (mat !== null) {
        var centerRow = Math.floor(mat.length / 2),
          centerCol = Math.floor(mat[0].length / 2),
          matTotal = mat.length * mat[0].length,
          matRow,
          matCol,
          offset,
          divider;
      }
      // Color effect matrix
      if (settings.color !== null) colorMat = colorEffects[settings.color];

      // Loop through each pixel
      for (row = 0; row < src.height; row++) {
        for (col = 0; col < src.width * 4; col++) {
          // Skip alpha channel
          if (channel === 3) {
            dest.data[current] = src.data[current]; // Alpha max
            current++;
            channel = 0;
            continue;
          }
          sum = 0;
          divider = matTotal;

          /*
           * Apply color effect, if selected. Only apply on first channel
           */
          if (colorMat !== null) {
            sum = src.data[current - channel] * colorMat[channel][0]; // R
            sum += src.data[current - channel + 1] * colorMat[channel][1]; // G
            sum += src.data[current - channel + 2] * colorMat[channel][2]; // B
            sum = Math.min(Math.max(sum / 3, 0), 255);
            dest.data[current] = sum;
            sum = 0;
          }

          if (mat !== null) {
            /*
             * Now loop through the effect matrix. This gives
             * more freedom when developing filters, since it allows
             * convolutions with matrixes of any size.
             */
            for (matRow = 0; matRow < mat.length; matRow++) {
              for (matCol = 0; matCol < mat[0].length; matCol++) {
                // Skip 0 values
                if (mat[matRow][matCol] === 0) continue;

                offset = 0;
                // Now get the index of the corresponding pixel
                // Vertical index
                if (matRow < centerRow) {
                  offset -= (centerRow - matRow) * src.width * 4;
                } else if (matRow > centerRow) {
                  offset += (matRow - centerRow) * src.width * 4;
                }
                // Horizontal index
                offset += (centerCol - matCol) * 4;

                // Add to sum if boundaries are ok
                if (current + offset < 0 || offset > src.data.length) {
                  divider--; // If the pixel is not used, dont divide by it.
                } else {
                  sum += mat[matRow][matCol] * src.data[current + offset];
                }
              }
            }
          }

          // Fix and check boundaries of sum
          if (mat !== null) {
            sum /= divider;
            sum = Math.min(Math.max(sum, 0), 255);

            // Store sum
            if (mat !== null) dest.data[current] = sum;
          }

          //if(current > 10 && sum > 0) return;

          current++;
          channel++;
        }
      }
      // Store in destination canvas
      destCtx.putImageData(dest, 0, 0);

      if (settings.replace) {
        if (obj.is("img")) $("img").attr("src", save());
        else srcCtx.putImageData(dest, 0, 0);
        return obj;
      } else {
        // Return image data
        return destCanvas; //save();
      }
    }
    /**
     * Generates a data URL for the canvas
     */
    function save() {
      return destCanvas.toDataURL();
    }
  },
};
